<template>
  <div class="report-show">
    <div class="top-action-btns">
      <el-button type="primary" round size="small" @click="backToList">
        <i class="el-icon-back"></i> back to list
      </el-button>
      <el-button
        size="small"
        type="danger"
        round
        @click="downloadImage"
        v-if="!this.tindeReport">
        <i class="el-icon-download"></i> Download
      </el-button>
    </div>
    <div class="top-bar-report">
      <div class="title-block">Results</div>
        <div class="details-block">
            <div class="title-block-m">DETAILS</div>
            <div class="item date">
                <div class="item-title">
                    SCAN DATE:
                </div>
                <div class="item-data">
                    {{ reportInfo.created_at }}
                </div>
            </div>
            <div class="item email" v-if="!this.tindeReport">
                <div class="item-title">
                    PARTNER’S EMAIL:
                </div>
                <div class="item-data">
                    {{ reportInfo.email }}
                </div>
            </div>
            <div class="item report-id">
                <div class="item-title">
                    SCAN NUMBER:
                </div>
                <div class="item-data">
                    {{ reportInfo.id }}
                </div>
            </div>
        </div>
    </div>
    <div class="result-wrp" v-if="!this.tindeReport">
      <div class="scan-itm">
        <div class="net-name">
          <b>Network</b>
        </div>
        <div class="result">
          <b>Result</b>
        </div>
      </div>
      <div v-for="itm of reportData" class="scan-itm" :key="itm.id">
        <div class="net-name">
          <a :href="itm.network_url" target="_blank">{{ itm.network_name }}</a>
        </div>
        <div class="result" v-if="itm.status === 1">
          <el-tag type="danger" v-if="itm.result">Busted</el-tag>
          <el-tag type="success" v-else>No Account</el-tag>
        </div>
        <div class="result" v-if="itm.status === 0">
          <el-tag type="warning">Not Ready</el-tag>
        </div>
      </div>
    </div>
    <div class="result-wrp" v-else>
      <el-table :data="reportData">
        <el-table-column label="Name" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Age" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.age }}</span>
          </template>
        </el-table-column>
        <el-table-column label="User ID">
          <template slot-scope="scope">
            <span>{{ scope.row.tinder_id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Image">
          <template slot-scope="scope">
            <img class="tinder_image" :src="scope.row.image_url" alt="">
          </template>
        </el-table-column>
        <el-table-column label="Super Search" width="150">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.super_search }}</span> -->
            <span v-if="scope.row.super_search" class="el-tag el-tag--success">Yes</span>
            <span v-else class="el-tag el-tag--error">No</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'ReportShow',
    props: {
      reportData: Array,
      reportInfo: Object,
    },
    data () {
      return {
        tindeReport: false,
      }
    },
    created() {
      this.tindeReport = this.reportInfo.location_address ?  true : false
    },

    methods: {
      backToList () {
        this.$store.dispatch('users/clearReport')
        this.$router.go(-1);
      },

      downloadImage(){
        this.$store.dispatch('users/downloadImage', this.reportInfo)
      }
    },
  }
</script>

<style scoped lang="scss">
  .tinder_image {
    max-width: 100px;
    max-height: 100px;
  }
  .report-show {
    padding: 0 25px;
  }
  .top-action-btns{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 10px;
  }
  .top-bar-report {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 25px;
    margin-bottom: 50px;
  }

  .title-block {
    font-size: 32px;
    font-weight: 800;
  }

  .title-block-m {
    font-size: 24px;
    font-weight: 700;
  }

  .details-block {
    .item {
      display: flex;
      font-size: 15px;
      margin-bottom: 5px;
      .item-title {
        min-width: 150px;
        text-transform: uppercase;
      }
    }
  }

  .scan-itm {
    margin-bottom: 15px;
    border-bottom: 2px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 5px;
  }
</style>
